import React, { Fragment } from 'react';
import { INotificationLayoutProps } from '../../../../notifications/notifications.models';
import confettiLottie from '../../../../design/lottie/confetti.lottie.json';
import { LottieAsset } from '../../../../design/lottie/lottie-asset/lottie-asset';
import { Button, KeplerPoints } from '@keplerco/core';
import styles from './skills-gap-report-modal.module.css';
import classNames from 'classnames';

export function SkillsGapReportModalLayout(props: INotificationLayoutProps): JSX.Element {
  return (
    <Fragment>
      <div className="dialogBackground">
        <LottieAsset loop autoplay data={confettiLottie} />
      </div>

      <div className="modalContent">
        <div className="badgeIconContainer">
          <object data="/badges/badge_Astronaut.svg" type="image/svg+xml">
            <img src="/badges/badge_Astronaut.svg" alt="Astronaut" />
          </object>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 30, alignItems: 'center', textAlign: 'center' }}>
          <h2>Stellar Job!</h2>

          <h3>
            You've earned a total of
            <span className="h2">
              <KeplerPoints trimWhiteSpace points={Math.round(props.amount ?? 0)} />
            </span>
            for completing your skills assessment.
          </h3>

          {props.awardBreakdowns && (
            <ul className={styles.list}>
              {props.awardBreakdowns?.map(award => {
                return (
                  <li key={award.description} className={styles.listItem}>
                    <div className={classNames('card', styles.card)}>
                      <span className="caption">{award.description}</span>

                      <h3>
                        +<KeplerPoints points={Math.round(award.amount)} />
                      </h3>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}

          <Button onClick={props.onAction} chubby type={'button'} filled arrow={false}>
            Great, Thanks!
          </Button>
        </div>
      </div>
    </Fragment>
  );
}
